/* ===== Stambolian: SKU-aware luxury search ===== */
/* Shows ALL close SKU matches (B82 -> B82-1..B82-4); never auto-redirects. */
/* SKU dataset is lazy-loaded from window.STBL_SKU_SRC on first search focus. */
(function(){
  if (window.__stblSkuInit) return;
  window.__stblSkuInit = true;

  var loaded = false, loading = false, pendingInput = null;

  function srcs(){
    if (window.STBL_SKU_SRCS && window.STBL_SKU_SRCS.length) return window.STBL_SKU_SRCS;
    if (window.STBL_SKU_SRC) return [window.STBL_SKU_SRC];
    return [];
  }

  function loadData(cb){
    if (loaded){ if (cb) cb(); return; }
    if (loading){ return; }
    var list = srcs();
    if (!list.length) return;
    loading = true;
    var i = 0;
    function next(){
      if (i >= list.length){
        loaded = true; loading = false;
        if (cb) cb();
        if (pendingInput){ var p = pendingInput; pendingInput = null; try{ handle(p); }catch(e){} }
        return;
      }
      var s = document.createElement('script');
      s.src = list[i++]; s.async = false;
      s.onload = next;
      s.onerror = function(){ loading = false; };
      document.head.appendChild(s);
    }
    next();
  }

  function data(){ return window.STBL_SKU || []; }

  function isSkuQuery(q){
    q = (q || '').trim();
    if (q.length < 2) return false;
    if (/\s/.test(q)) return false;            // SKUs have no spaces
    return /^[A-Za-z]{1,4}\d/.test(q);         // letters then a digit (ES159, B82-2, P53102, E19GR-...)
  }

  function fmtPrice(n){
    n = Math.round(Number(n) || 0);
    return '$' + n.toLocaleString('en-US');
  }
  function priceLabel(r){
    if (r.pm && r.pm !== r.p) return 'From ' + fmtPrice(r.p);
    return fmtPrice(r.p);
  }
  function thumb(url){
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }

  function matchSku(q){
    var norm = q.trim().toUpperCase();
    var out = [], seen = {};
    var arr = data();
    for (var i=0;i<arr.length;i++){
      var r = arr[i], best=null, exact=false;
      if (!r.s) continue;
      for (var j=0;j<r.s.length;j++){
        var su = (r.s[j]||'').toUpperCase();
        if (!su) continue;
        if (su === norm){ best = r.s[j]; exact = true; break; }
        if (su.indexOf(norm) === 0){ if(!best){ best = r.s[j]; } }       // prefix: B82 -> B82-2
        else if (su.split('-')[0] === norm){ if(!best){ best = r.s[j]; } } // base match
      }
      if (best && !seen[r.h]){
        seen[r.h] = 1;
        out.push({ r:r, sku:best, exact:exact });
      }
    }
    out.sort(function(a,b){
      if (a.exact !== b.exact) return a.exact ? -1 : 1;
      return a.sku.localeCompare(b.sku);
    });
    return out.slice(0, 16);
  }

  function esc(s){ return (s||'').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function renderHTML(matches, q){
    var rows = matches.map(function(m){
      var r = m.r;
      return ''
        + '<a class="stbl-sku-row" href="/products/' + esc(r.h) + '">'
        +   (r.i ? '<img class="stbl-sku-thumb" src="' + esc(thumb(r.i)) + '" alt="" loading="lazy">' : '<span class="stbl-sku-thumb"></span>')
        +   '<span class="stbl-sku-info">'
        +     '<span class="stbl-sku-title">' + esc(r.t) + '</span>'
        +     '<span class="stbl-sku-meta">'
        +       '<span class="stbl-sku-code">' + esc(m.sku) + '</span>'
        +       '<span class="stbl-sku-price">' + priceLabel(r) + '</span>'
        +     '</span>'
        +   '</span>'
        +   '<span class="stbl-sku-arrow">&rsaquo;</span>'
        + '</a>';
    }).join('');
    var label = matches.length === 1 ? 'Matching Piece' : matches.length + ' Matching Pieces';
    return '<div class="container"><div class="stbl-sku-head">' + label + '</div><div class="stbl-sku-list">' + rows + '</div></div>';
  }

  function ensurePanel(form){
    if (!form) return null;
    var panel = form.querySelector('#stbl-sku-panel');
    if (!panel){
      panel = document.createElement('div');
      panel.id = 'stbl-sku-panel';
      panel.className = 'quickSearchResultsBlock quickSearchResultsWrap';
      var pred = form.querySelector('.predictive-search--header') || form.querySelector('#predictive-search-results');
      if (pred && pred.parentNode){ pred.parentNode.insertBefore(panel, pred.nextSibling); }
      else { form.appendChild(panel); }
    }
    return panel;
  }

  function handle(input){
    var q = input.value || '';
    var form = input.closest('predictive-search') || input.closest('form') || input.parentNode;
    if (!form) return;
    if (isSkuQuery(q)){
      if (!loaded){ pendingInput = input; loadData(); return; }   // wait for dataset, then re-handle
      var panel = ensurePanel(form);
      var m = matchSku(q);
      if (m.length){
        if (panel) panel.innerHTML = renderHTML(m, q);
        form.classList.add('stbl-sku-on');
        return;
      }
    }
    form.classList.remove('stbl-sku-on');
    var p0 = form.querySelector('#stbl-sku-panel');
    if (p0) p0.innerHTML = '';
  }

  var timer;
  function debounced(input){
    clearTimeout(timer);
    timer = setTimeout(function(){ try{ handle(input); }catch(e){} }, 120);
  }

  // Preload the dataset as soon as the user focuses any search field
  document.addEventListener('focusin', function(e){
    var t = e.target;
    if (t && t.classList && t.classList.contains('search__input')) loadData();
  }, true);

  document.addEventListener('input', function(e){
    var t = e.target;
    if (t && t.classList && t.classList.contains('search__input')) debounced(t);
  }, true);

  // clear on empty
  document.addEventListener('keyup', function(e){
    var t = e.target;
    if (t && t.classList && t.classList.contains('search__input') && !(t.value||'').trim()){
      var form = t.closest('predictive-search') || t.closest('form');
      if (form){ form.classList.remove('stbl-sku-on'); var p=form.querySelector('#stbl-sku-panel'); if(p) p.innerHTML=''; }
    }
  }, true);
})();

/* ===== Stambolian: title-scoped search relevance =====
   The native full-search results page matches product descriptions + tags,
   so e.g. "kunzite" returned 139 results (only 4 are actually kunzite pieces).
   This scopes word searches to product TITLES (+ keeps SKU search via the SKU panel),
   then restores a clean display term in the search box + results heading.            */
(function(){
  if (window.__stblRelInit) return;
  window.__stblRelInit = true;

  // letters-then-digit, no spaces  => treat as SKU, leave to native/SKU panel
  function isSku(q){
    q = (q||'').trim();
    if (q.length < 2) return false;
    if (/\s/.test(q)) return false;
    return /^[A-Za-z]{1,4}\d/.test(q);
  }

  // SKU queries -> scope to variants.sku ; word queries -> scope to title (AND, prefix)
  function scope(raw){
    raw = (raw||'').trim();
    if (!raw) return null;
    if (raw.indexOf('title:') !== -1 || raw.indexOf('variants.sku:') !== -1) return null; // already scoped
    if (isSku(raw)){
      var sk = raw.replace(/["':*\s]/g,'');
      return sk ? 'variants.sku:' + sk + '*' : null;
    }
    var toks = raw.split(/\s+/)
      .map(function(t){ return t.replace(/["':*]/g,'').trim(); })
      .filter(function(t){ return t.length; });
    if (!toks.length) return null;
    return toks.map(function(t){ return 'title:' + t + '*'; }).join(' ');
  }

  function isScoped(s){ return (s||'').indexOf('title:') !== -1 || (s||'').indexOf('variants.sku:') !== -1; }

  function cleanTerm(s){
    return (s||'').replace(/variants\.sku:/g,'').replace(/title:/g,'').replace(/\*/g,'').replace(/\s+/g,' ').trim();
  }

  // ---- 1) rewrite the q value on search-form submit (primary, no extra load) ----
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = (form.getAttribute('action')||'') ;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    if (action.indexOf('/search') === -1 && !input.classList.contains('search__input')) return;
    var s = scope(input.value);
    if (s) input.value = s;
  }, true);

  // ---- 2) rewrite "view all results" links in the predictive dropdown ----
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/search?"]') : null;
    if (!a) return;
    try{
      var u = new URL(a.href, location.origin);
      var q = u.searchParams.get('q');
      var s = scope(q);
      if (s){ u.searchParams.set('q', s); a.href = u.toString(); }
    }catch(_){}
  }, true);

  // ---- 3) safety net: scope unscoped word searches that land on results page ----
  (function guard(){
    if (location.pathname.indexOf('/search') !== 0) return;
    var u = new URL(location.href);
    var q = u.searchParams.get('q');
    var s = scope(q);
    if (s){
      u.searchParams.set('q', s);
      if ((u.searchParams.get('type')||'') === '') u.searchParams.set('type','product');
      location.replace(u.toString());
    }
  })();

  // ---- 4) restore clean display term on a scoped results page ----
  function strip(s){ return (s||'').replace(/variants\.sku:/g,'').replace(/title:/g,'').replace(/\*/g,''); }
  function tidy(){
    if (location.pathname.indexOf('/search') !== 0) return;
    var q = new URL(location.href).searchParams.get('q') || '';
    if (!isScoped(q)) return;
    var disp = cleanTerm(q);
    // search inputs
    var inputs = document.querySelectorAll('input[name="q"], .search__input');
    for (var i=0;i<inputs.length;i++){
      if (isScoped(inputs[i].value)) inputs[i].value = disp;
    }
    // results heading + page title
    var h = document.querySelector('h1.page-header, .search-results__title, .template-search h1');
    if (h && isScoped(h.textContent)){ h.textContent = strip(h.textContent); }
    if (isScoped(document.title)){ document.title = strip(document.title); }
  }
  if (document.readyState !== 'loading') tidy();
  else document.addEventListener('DOMContentLoaded', tidy);
})();
